import type { SVGProps } from 'react';
const SvgNotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#notes_svg__a)">
      <path
        fill="currentColor"
        d="M3 18h12v-2H3v2ZM3 6v2h18V6H3Zm0 7h18v-2H3v2Z"
      />
    </g>
    <defs>
      <clipPath id="notes_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNotes;
